import { createSelector } from 'reselect'

export const getUserPackageInactiveMsg = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.packageInactiveMessage
    ? state.user.profile.packageInactiveMessage
    : '',
  packageInactiveMessage => packageInactiveMessage
)
